/**
 * 문제집 업로드 결과 표시 컴포넌트
 * - 업로드 성공 시: 문제 개수, 이미지 개수 표시
 * - 업로드 실패 시: 에러 목록 표시
 */

import React from 'react';
import { Alert, List } from 'antd';
import type { WorkbookUploadResponse } from '../../types/workbook';

interface ValidationResultProps {
  result: WorkbookUploadResponse | null;
}

/**
 * ValidationResult 컴포넌트
 * @param result - 업로드 결과 (성공/실패 정보)
 */
export const ValidationResult: React.FC<ValidationResultProps> = ({ result }) => {
  // 결과가 없으면 렌더링하지 않음
  if (!result) {
    return null;
  }

  // 업로드 성공 시
  if (result.success) {
    return (
      <Alert
        message="업로드 성공"
        description={
          <div>
            <p>
              문제집이 성공적으로 업로드되었습니다.
            </p>
            <ul style={{ marginTop: 8, marginBottom: 0 }}>
              {result.problems_count !== undefined && (
                <li>문제 개수: <strong>{result.problems_count}개</strong></li>
              )}
              {result.images_uploaded !== undefined && (
                <li>업로드된 이미지: <strong>{result.images_uploaded}개</strong></li>
              )}
              {result.workbook && (
                <li>문제집명: <strong>{result.workbook.name}</strong></li>
              )}
            </ul>
          </div>
        }
        type="success"
        showIcon
        style={{ marginTop: 16 }}
      />
    );
  }

  // 업로드 실패 시
  return (
    <Alert
      message="업로드 실패"
      description={
        <div>
          <p>다음 문제를 해결해주세요:</p>
          <List
            size="small"
            dataSource={result.errors || ['알 수 없는 오류가 발생했습니다']}
            renderItem={(error) => (
              <List.Item style={{ padding: '4px 0', border: 'none' }}>
                • {error}
              </List.Item>
            )}
            style={{ marginTop: 8 }}
          />
        </div>
      }
      type="error"
      showIcon
      style={{ marginTop: 16 }}
    />
  );
};
